import ApiService from "./ApiService";

const CreditorService = {
  getCreditors() {
    let inputData = {
      endPoint: "creditor-list",
      addditionalHeaderData: {},
      postData: {},
    };
    return ApiService.getCall(inputData);
  },

  getCreditor(slug) {
    let inputData = {
      endPoint: "creditor-show/" + slug,
      addditionalHeaderData: {},
      postData: {},
    };
    return ApiService.getCall(inputData);
  },

  createCreditor(postData) {
    let inputData = {
      endPoint: "creditor-add",
      addditionalHeaderData: {},
      postData: postData,
    };
    return ApiService.postCall(inputData);
  },

  updateCreditor(postData) {
    let inputData = {
      endPoint: "creditor-update",
      addditionalHeaderData: {},
      postData: postData,
    };
    return ApiService.postCall(inputData);
  },

  deleteCreditor(slug) {
    let inputData = {
      endPoint: "creditor-delete",
      addditionalHeaderData: {},
      postData: { slug: slug },
    };
    return ApiService.postCall(inputData);
  },
};

export default CreditorService;
